export default __webpack_public_path__ + "static/media/flex-price.6ed32fac.svg";